import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import MainURL from '../MainURL';
import { recoilLoginState } from '../RecoilStore';
import { ADMIN_MENUS, Icon, PageHead } from './AdminLayout';

export default function Main( props: any) {

  const navigate = useNavigate();
  const isLogin = useRecoilValue(recoilLoginState);
  const [counts, setCounts] = useState<{ program: number | null; support: number | null; popup: number | null; popupOn: number | null }>(
    { program: null, support: null, popup: null, popupOn: null }
  );

  useEffect(() => {
    if (!isLogin) {
      alert('로그인이 필요합니다.');
      navigate('/admin');
      return;
    }
    Promise.allSettled([
      axios.get(`${MainURL}/main/getgalleryprogram`),
      axios.get(`${MainURL}/main/getgallerysupport`),
      axios.get(`${MainURL}/main/getpopups/all`),
    ]).then(([program, support, popup]) => {
      const list = (r: PromiseSettledResult<any>) => (r.status === 'fulfilled' && Array.isArray(r.value.data) ? r.value.data : null);
      const popups = list(popup);
      setCounts({
        program: list(program)?.length ?? null,
        support: list(support)?.length ?? null,
        popup: popups?.length ?? null,
        popupOn: popups ? popups.filter((p: any) => p.isActive).length : null,
      });
    });
  }, []);

  const show = (n: number | null) => (n === null ? '–' : n);

  return (
    <>
      <PageHead title="메인 관리"
        desc="관리할 항목을 선택하세요. 홈페이지에 노출되는 내용과 갤러리 · 후원 자료를 이곳에서 수정합니다." />

      <div className="ad-stats">
        <div className="ad-stat">
          <p>프로그램 갤러리</p><b>{show(counts.program)}</b><small>등록된 사진</small>
        </div>
        <div className="ad-stat">
          <p>후원물품 갤러리</p><b>{show(counts.support)}</b><small>등록된 사진</small>
        </div>
        <div className="ad-stat">
          <p>팝업</p><b>{show(counts.popup)}</b>
          <small>{counts.popupOn === null ? '등록된 팝업' : `사용 중 ${counts.popupOn}개`}</small>
        </div>
      </div>

      <div className="ad-card ad-card__pad">
        <h2 style={{ marginBottom: 14 }}>관리 메뉴</h2>
        <div className="ad-tiles">
          {ADMIN_MENUS.filter((m) => m.key !== 'main').map((m) => (
            <button type="button" key={m.key} className="ad-tile" onClick={() => navigate(m.url)}>
              <Icon name={m.icon} />
              {m.title}
            </button>
          ))}
          <button type="button" className="ad-tile" onClick={() => navigate('/admin/backup')}>
            <Icon name="backup" />
            백업
          </button>
          <a className="ad-tile ad-tile--line" href="/" target="_blank" rel="noopener noreferrer">
            <Icon name="external" />
            사이트 보기 <small>새 창</small>
          </a>
        </div>
      </div>
    </>
  );
}
